module.exports = __webpack_public_path__ + "img/vip_bg1.f46381e6.png";